"use client";

import { useEffect } from "react";
import { ErrorBoundaryProps } from "@/types/ErrorBoundaryType";
import styles from "./global-error.module.scss";

// global-error replaces the entire root layout: no <html>/<body>, no providers,
// and no global stylesheet — so it renders its own document shell, uses hardcoded
// German (useGlobalContext is unavailable here), and scopes styles via a CSS module.
const GlobalError = ({ error, reset }: ErrorBoundaryProps) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="de">
      <body>
        <main role="alert" className={styles["global-error"]}>
          <div className={styles["global-error-inner"]}>
            <h1 className={styles["global-error-headline"]}>
              Etwas ist schiefgelaufen
            </h1>
            <p className={styles["global-error-message"]}>
              Beim Laden der Seite ist ein Fehler aufgetreten. Bitte versuchen
              Sie es erneut.
            </p>
            <button
              type="button"
              className={styles["global-error-button"]}
              onClick={() => reset()}
            >
              Erneut versuchen
            </button>
          </div>
        </main>
      </body>
    </html>
  );
};

export default GlobalError;
